export default "__VITE_ASSET__DhWN716P__"